// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_oo-0";
export var buttonContainer = "_oo-3";
export var cancelButton = "_oo-4";
export var headerSection = "_oo-6";
export var headerTitle = "_oo-9";
export var messageSideLeft = "_oo-1";
export var messageSideRight = "_oo-2";
export var orderNumberContainer = "_oo-7";
export var orderNumberLabel = "_oo-8";
export var submitButton = "_oo-5";